/**
 * Triggers a file download by handing the URL directly to the browser via a
 * hidden anchor click.
 *
 * For presigned S3 URLs the browser will open a native download stream
 * immediately (progress shown in the downloads bar) rather than buffering the
 * entire file into JS heap memory first, which was the cause of the perceived
 * >1 s delay before any download feedback appeared.
 *
 * S3 serves binary files (ZIP, PDF) with "Content-Disposition: attachment"
 * which tells the browser to download rather than navigate — no new tab needed.
 * The `download` attribute is a best-effort filename hint (only honoured for
 * same-origin); for cross-origin S3 URLs the browser uses the filename from
 * the Content-Disposition header instead.
 */
export const downloadFile = (fileURL: string, fileName?: string): void => {
  // Derive the filename from the URL path as a fallback.
  const urlPath = fileURL.split('?')[0];
  const derivedName = decodeURIComponent(urlPath.substring(urlPath.lastIndexOf('/') + 1));
  const downloadName = fileName || derivedName;

  const a = document.createElement('a');
  a.href = fileURL;
  a.setAttribute('download', downloadName);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
